// Peças com pré-visualização em fotografia real: a fotografia base e, por zona, uma máscara com as sombras da própria fotografia
// (gerados por tools/chroma/make_zones.py). O id de cada zona é o id da "parte" da peça (slot) que escolhe o padrão dessa zona.
// Posições em pixéis da imagem base (800 de largura).
export const CHROMA = {
  // Coelhinho: fotografias de estúdio (fundo branco) em tecido liso e branco; as zonas (orelhas e gola) vêm de tools/chroma/make_coelhinho.py.
  coelhinho: {
    dir: "/img/chroma/coelhinho",
    width: 800,
    height: 1066,
    focus: { x: 20, y: -40, w: 760, h: 1150 },
    cutout: true, // só a peça (cutout.png), sobre o fundo claro da pré-visualização, como as outras peças
    shadowY: 1024,
    neutral: 215, // máscaras com a luminância das pregas e sombras, normalizada: só escurece
    contrast: 1,
    zones: [{ id: "orelhas", tile: 0.3, gain: 1.5 }, { id: "gola", tile: 0.26, gain: 1.5 }],
    ears: { esquerda: { x: 312, y: 200, rotate: -95 }, direita: { x: 540, y: 232, rotate: -85 } },
  },
  // Lacinho: fotografia de est�dio (fundo branco) em tecido liso e branco; a zona do tecido vem de tools/chroma/make_lacinho.py.
  lacinho: {
    dir: "/img/chroma/lacinho",
    width: 800,
    height: 533,
    focus: { x: 40, y: 50, w: 720, h: 440 },
    cutout: true,
    shadowY: 462,
    neutral: 215,
    contrast: 1,
    zones: [{ id: "tecido", tile: 0.3, gain: 1.3 }],
  },
  // Tapa-fraldas: fotografia de estúdio (fundo branco) em tecido liso e branco; a zona do tecido vem de tools/chroma/make_tapa_fraldas.py.
  "tapa-fraldas-reversivel": {
    dir: "/img/chroma/tapa-fraldas",
    v: 2, // sobe quando as imagens mudam (as antigas ficam em cache uma semana)
    width: 800,
    height: 936,
    focus: { x: 0, y: 150, w: 800, h: 770 },
    cutout: true, // só a peça (cutout.png), sobre o fundo claro da pré-visualização, como o coelhinho
    shadowY: 878,
    neutral: 215,
    contrast: 1,
    zones: [{ id: "tecido", tile: 0.3, gain: 1.1 }],
    names: { frente: { x: 400, y: 560, width: 300, size: 72 }, cinta: { x: 400, y: 300, width: 360, size: 36 } },
  },
};
// Peças com mais de uma vista na pré-visualização (a primeira é a de partida).
export const VIEWS = {
};
export const viewsOf = (product) => VIEWS[product?.slug] ?? null;

export const chromaOf = (product) => CHROMA[product?.slug] ?? null;
